

const FileUpload = 'https://emfbk.soucient.com/media/'

export default FileUpload